import Partner from './PartnerSalonComponent'
import SalonPage from './v2/SalonPage'

// Partner (produkty i artykuły) — dotychczasowy widok; dealer — wizytówka z ofertą (props z lib/salon/salonPage).
function SalonComponent (props) {
	return props.salon?.is_partner ? <Partner {...props} /> : <SalonPage {...props} />
}

export default SalonComponent
